//verification portal code 
import React, { useEffect, useState } from "react";
import {
  Button,
  Container,
  Box,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import dayjs from "dayjs";
import PersonalDetail from "./PersonalDetail";
import EducationalDetail from "./EducationalDetail";
import Experince from "./Experince";
import {
  PostData,
  uploadImageFireBase,
  updateDataByID,
  getDataById,
} from "../../../Utils/firebaseServices";
import { v4 as uuidv4 } from "uuid";
import FormSubmit from "./FormSubmit";
import { Snackbar, Alert, Slide, LinearProgress } from "@mui/material";
import { useRef } from "react";

const defaultExperienceFields = {
  comp_name: "",
  Exp_years: "",
  doj: "",
  doe: "",
  doc_offerLetter: [],
  doc_relievingLetter: [],
  doc_salarySlip: [],
  doc_experienceLetter: [],
};

const getInitialStatefixedId = () => {
  let savedfixedId = localStorage.getItem("verivication_portal_fixedId");

  if (!savedfixedId) {
    savedfixedId = uuidv4();
    localStorage.setItem("verivication_portal_fixedId", savedfixedId);
  }
  return savedfixedId;
};

const EmployeeForm = () => {
  const [userportaldata, setuserPortalData] = useState({
    Educational: {},
    Experience: [{ id: 1, ...defaultExperienceFields }],
  });
  const [activeStep, setActiveStep] = useState(0);
  const [experienceFields, setExperienceFields] = useState([{ id: 1 }]);
  const [experince, setExperince] = useState(() => {
    return JSON.parse(localStorage.getItem("user_experience")) || false;
  });
  const [errors, setErrors] = useState({});
  const [graduationchecked, setgraduationchecked] = useState(false);
  const [postgraduate, setPostgraduate] = useState(false);
  const [Percente, setPercent] = useState({});
  const [userId, setUserId] = useState("");
  const [userfixedId] = useState(getInitialStatefixedId);
  const [open, setOpen] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const thresholdRef = useRef(3);

  useEffect(() => {
    localStorage.setItem("user_experience", JSON.stringify(experince));
  }, [experince]);

  useEffect(() => {
    let res = localStorage.getItem("verivication_portal_id");
    res && getDataById("financeUserPortal", res, handleInitialization);
  }, []);
  const handleInitialization = (res) => {
    try {
      if (!res) {
        setErrorMessage("No data found for initialization");
        setOpen(true);
        return;
      }

      const updatedEducational = res.Educational ?? {};
      const updatedExperience =
        res.Experience && res.Experience.length > 0
          ? res.Experience
          : [{ id: 1, ...defaultExperienceFields }];

      setuserPortalData({
        email: res.email || "",
        password: res.password || "",
        name: res.name || "",
        fatherName: res.fatherName || "",
        motherName: res.motherName || "",
        mobilno: res.mobilno || "",
        dob: res.dob || "",
        gender: res.gender || "",
        Educational: updatedEducational,
        Experience: updatedExperience,
      });
      setExperienceFields(updatedExperience);
      setUserId(res.id || "");
      console.log("Initialized data:", res);
    } catch (error) {
      setErrorMessage("Error initializing data: " + error.message);
      setOpen(true);
    }
  };

  const handleAddExperience = () => {
    const newId = experienceFields.length + 1;
    setExperienceFields((prev) => [...prev, { id: newId }]);
    setuserPortalData((prevData) => ({
      ...prevData,
      Experience: [
        ...(prevData.Experience || []),
        { id: newId, ...defaultExperienceFields },
      ],
    }));
  };

  const handleRemoveExperience = (id) => {
    setExperienceFields((prev) => {
      if (prev.length === 1) return prev;
      return prev.filter((exp) => exp.id !== id);
    });

    setuserPortalData((prevData) => {
      if (prevData.Experience.length === 1) return prevData;
      return {
        ...prevData,
        Experience: prevData.Experience.filter((exp) => exp.id !== id),
      };
    });
  };

  const handleExperienceChange = (e, id) => {
    const { name, value, files } = e.target;

    if (!value && (!files || files.length === 0)) return;

    if (files && files.length > 0) {
      const uploadedFiles = Array.from(files);
      const unicId = uuidv4();
      const sanitizedName = userportaldata.name.replace(/\s+/g, "_");

      uploadedFiles.forEach((file) => {
        const sanitizedFileName = file.name.replace(/\s+/g, "_");

        if (!["application/pdf", "image/jpeg"].includes(file.type)) {
          setErrorMessage("Only PDF and JPG files are allowed!");
          setOpen(true);
          setPercent({ name: null });
          return;
        }

        const storagePath = `verificationPortalData/${userfixedId}_${sanitizedName}_${userportaldata.mobilno}/${unicId}_${sanitizedName}_${userportaldata.mobilno}_${sanitizedFileName}`;

        const fileSize = file.size;
        const isSmallFile = fileSize < 500 * 1024;
        let simulatedProgress = 0;
        let progressInterval;

        if (isSmallFile) {
          progressInterval = setInterval(() => {
            simulatedProgress += 15;
            if (simulatedProgress >= 100) {
              clearInterval(progressInterval);
              return;
            }
            setPercent((prevState) => ({
              ...prevState,
              [`${id}_${name}_progress`]: simulatedProgress,
            }));
          }, 80);
        }

        uploadImageFireBase(
          storagePath,
          file,
          (downloadURL) => {
            if (isSmallFile && progressInterval) {
              clearInterval(progressInterval);
              setPercent((prevState) => ({
                ...prevState,
                [`${id}_${name}_progress`]: 100,
              }));
            }

            setuserPortalData((prevData) => {
              const updatedData = structuredClone(prevData);
              const updatedExperience = updatedData.Experience || [];

              const expIndex = updatedExperience.findIndex(
                (exp) => exp.id === id
              );

              if (expIndex !== -1) {
                const existingEntry = updatedExperience[expIndex];
                const currentFiles = existingEntry[name] || [];

                updatedExperience[expIndex] = {
                  ...existingEntry,
                  [name]: [...currentFiles, downloadURL],
                };
              } else {
                updatedExperience.push({
                  id,
                  ...defaultExperienceFields,
                  [name]: [downloadURL],
                });
              }

              const filteredExperience = updatedExperience.map((exp) => ({
                ...exp,
                [name]: (exp[name] || []).filter((file) => file !== false),
              }));

              updateDataByID(
                userId,
                {
                  ...updatedData,
                  Experience: filteredExperience,
                },
                "financeUserPortal"
              );

              return {
                ...updatedData,
                Experience: filteredExperience,
              };
            });

            setPercent((prevState) => ({
              ...prevState,
              [`${id}_${name}_progress`]: null,
            }));
          },
          (progress) => {
            if (isSmallFile) return;
            setPercent((prevState) => ({
              ...prevState,
              [`${id}_${name}_progress`]: progress,
            }));
          },
          (error) => {
            if (progressInterval) clearInterval(progressInterval);
            setPercent((prevState) => ({
              ...prevState,
              [`${id}_${name}_progress`]: null,
            }));
            setErrorMessage("File upload failed: " + error.message);
            setOpen(true);
          }
        );
      });

      return;
    }

    setuserPortalData((prevData) => {
      const updatedData = structuredClone(prevData);
      const updatedExperience = updatedData.Experience || [];

      let newValue = value.toString();
      if (name === "comp_name" && Array.isArray(newValue)) {
        newValue = newValue.join("");
      }

      const experienceIndex = updatedExperience.findIndex(
        (exp) => exp.id === id
      );

      if (experienceIndex !== -1) {
        updatedExperience[experienceIndex] = {
          ...updatedExperience[experienceIndex],
          [name]: newValue,
        };
      } else {
        updatedExperience.push({
          id,
          ...defaultExperienceFields,
          [name]: newValue,
        });
      }

      updatedData.Experience = updatedExperience;
      return updatedData;
    });

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors[`${id}.${name}`];
      return newErrors;
    });
  };

  const handleDateChange = (id, newValue, field) => {
    setuserPortalData((prevData) => {
      const updatedData = { ...prevData };
      let newErrors = { ...errors };

      if (!updatedData.Experience) {
        updatedData.Experience = [];
      }
      const experienceIndex = updatedData.Experience.findIndex(
        (exp) => exp.id === id
      );
      if (!newValue) {
        newErrors[field] = "Date is required";
      } else {
        delete newErrors[`${id}.${field}`];
      }
      if (experienceIndex !== -1) {
        updatedData.Experience[experienceIndex] = {
          ...updatedData.Experience[experienceIndex],
          [field]: newValue ? dayjs(newValue).format("DD/MM/YYYY") : "",
        };
      } else {
        updatedData.Experience.push({
          id,
          ...defaultExperienceFields,
          [field]: newValue ? dayjs(newValue).format("DD/MM/YYYY") : "",
        });
      }
      setErrors(newErrors);
      return updatedData;
    });
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    setuserPortalData((prevData) => {
      const updatedData = { ...prevData };
      const newErrors = { ...errors };
      const validationRules = {
        textOnly: ["name", "fatherName", "motherName"],
        numbersOnly: ["mobilno", "altPhone", "pincode"],
      };
      const uploadFields = [
        "10th",
        "12th",
        "grad_degree",
        "grad_semone",
        "grad_semtwo",
        "grad_semthree",
        "grad_semfour",
        "grad_semfive",
        "grad_semsix",
        "grad_semseven",
        "grad_semeight",
        "postgrad_degree",
        "postgrad_semone",
        "postgrad_semtwo",
        "postgrad_semthree",
        "postgrad_semfour",
      ];

      if (validationRules.textOnly.includes(name)) {
        newErrors[name] = /^[A-Za-z\s]+$/.test(value)
          ? undefined
          : "Only alphabets allowed";
      }

      if (validationRules.numbersOnly.includes(name)) {
        newErrors[name] = /^\d+$/.test(value)
          ? undefined
          : "Only numbers allowed";
      }

      if (uploadFields.includes(name) || name === "gender") {
        delete newErrors[name];
      }
      setErrors(newErrors);

      if (uploadFields.includes(name) && files?.length > 0) {
        const sanitizedName = prevData.name.replace(/\s+/g, "_");
        const mobileNo = prevData.mobilno;
        const uploadedFiles = prevData.Educational?.[name]
          ? [...prevData.Educational[name]]
          : [];

        const processFiles = (index) => {
          if (index >= files.length) return;

          const file = files[index];
          const allowedTypes = [
            "application/pdf",
            "image/jpeg",
            "image/jpg",
            "image/png",
          ];
          if (!allowedTypes.includes(file.type)) {
            setErrorMessage("Only PDF, JPG, and PNG files are allowed!");
            setOpen(true);
            return;
          }

          const unicId = uuidv4();
          const sanitizedFileName = file.name.replace(/\s+/g, "_");
          const filePath = `verificationPortalData/${userfixedId}_${sanitizedName}_${mobileNo}/${unicId}_${sanitizedName}_${mobileNo}_${sanitizedFileName}`;

          const fileSize = file.size;
          const isSmallFile = fileSize < 500 * 1024;
          let simulatedProgress = 0;
          let progressInterval;

          if (isSmallFile) {
            progressInterval = setInterval(() => {
              simulatedProgress += 20;
              if (simulatedProgress >= 100) {
                clearInterval(progressInterval);
                return;
              }
              setPercent((prevState) => ({
                ...prevState,
                [`${name}_progress`]: simulatedProgress,
              }));
            }, 80);
          }

          uploadImageFireBase(
            filePath,
            file,
            (downloadURL) => {
              if (isSmallFile && progressInterval) {
                clearInterval(progressInterval);
                setPercent((prevState) => ({
                  ...prevState,
                  [`${name}_progress`]: 100,
                }));
              }

              const updatedUploadedFiles = [...uploadedFiles];
              const falseIndex = updatedUploadedFiles.indexOf(false);

              if (falseIndex !== -1) {
                updatedUploadedFiles[falseIndex] = downloadURL;
              } else {
                updatedUploadedFiles.push(downloadURL);
              }

              updateDataByID(
                userId,
                {
                  [`Educational.${name}`]: updatedUploadedFiles,
                },
                "financeUserPortal"
              );

              setuserPortalData((prev) => ({
                ...prev,
                Educational: {
                  ...prev.Educational,
                  [name]: updatedUploadedFiles,
                },
              }));

              setPercent((prevState) => ({
                ...prevState,
                [`${name}_progress`]: null,
              }));

              processFiles(index + 1);
            },
            (progress) => {
              if (isSmallFile) return;
              setPercent((prevState) => ({
                ...prevState,
                [`${name}_progress`]: progress,
              }));
            },
            (error) => {
              if (progressInterval) clearInterval(progressInterval);
              setPercent((prevState) => ({
                ...prevState,
                [`${name}_progress`]: null,
              }));
              setErrorMessage("File upload failed: " + error.message);
              setOpen(true);
            }
          );
        };

        processFiles(0);
      } else {
        updatedData[name] = files?.length > 0 ? files : value;
      }

      return updatedData;
    });
  };

  const handleRemovefile = (name, id, removeIndex) => {
    const removeEducationalFields = [
      "10th",
      "12th",
      "grad_degree",
      "grad_semone",
      "grad_semtwo",
      "grad_semthree",
      "grad_semfour",
      "grad_semfive",
      "grad_semsix",
      "grad_semseven",
      "grad_semeight",
      "postgrad_degree",
      "postgrad_semone",
      "postgrad_semtwo",
      "postgrad_semthree",
      "postgrad_semfour",
    ];
    const removeExperienceFields = [
      "doc_offerLetter",
      "doc_relievingLetter",
      "doc_salarySlip",
      "doc_experienceLetter",
    ];
    if (removeEducationalFields.includes(name)) {
      setuserPortalData((prevData) => {
        let existingFiles = prevData.Educational[name] || [];

        if (Array.isArray(existingFiles) && existingFiles.length > 0) {
          existingFiles = [false, ...existingFiles];
        } else {
          existingFiles = [false];
        }
        return {
          ...prevData,
          Educational: {
            ...prevData.Educational,
            [name]: existingFiles,
          },
        };
      });
    }

    if (removeExperienceFields.includes(name)) {
      setuserPortalData((prev) => {
        const updatedExperience = [...prev.Experience];
        const expIndex = updatedExperience.findIndex((exp) => exp.id === id);

        if (expIndex !== -1) {
          let existingFiles = [...(updatedExperience[expIndex][name] || [])];

          if (name === "doc_salarySlip") {
            if (removeIndex >= 0 && removeIndex < existingFiles.length) {
              existingFiles[removeIndex] = false;
            }
          } else {
            if (existingFiles.length > 0 && existingFiles[0] === false) {
              existingFiles = existingFiles.slice(1);
            }
            existingFiles = [false, ...existingFiles];
          }

          updatedExperience[expIndex] = {
            ...updatedExperience[expIndex],
            [name]: existingFiles,
          };
        } else {
          updatedExperience.push({
            id,
            ...defaultExperienceFields,
            [name]: [false],
          });
        }

        return { ...prev, Experience: updatedExperience };
      });
    }
  };

  const staticSteps = [
    {
      label: "Personal Details",
      content: () => (
        <PersonalDetail
          userportaldata={userportaldata}
          handleChange={handleChange}
          errors={errors}
          setErrors={setErrors}
          handleDateChange={(newValue, field) =>
            setuserPortalData((prev) => ({
              ...prev,
              [field]: dayjs(newValue).format("DD/MM/YYYY"),
            }))
          }
        />
      ),
    },
    {
      label: "Educational Detail",
      content: () => (
        <EducationalDetail
          userportaldata={userportaldata}
          handleChange={handleChange}
          graduationchecked={graduationchecked}
          setgraduationchecked={setgraduationchecked}
          postgraduate={postgraduate}
          setPostgraduate={setPostgraduate}
          errors={errors}
          Percente={Percente}
          handleRemovefile={handleRemovefile}
          handleDateChange={(newValue, field) =>
            setuserPortalData((prev) => ({
              ...prev,
              [field]: dayjs(newValue).format("DD/MM/YYYY"),
            }))
          }
        />
      ),
    },
    {
      label: "Experience",
      content: () => (
        <>
          {experienceFields.map((exp, index) => {
            const experienceData = Array.isArray(userportaldata?.Experience)
              ? userportaldata.Experience[index] || defaultExperienceFields
              : defaultExperienceFields;
            return (
              <Box
                key={exp.id}
                sx={{
                  mb: 2,
                }}
              >
                {index >= 0 ? (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={experince}
                        onChange={(e) => setExperince(e.target.checked)}
                      />
                    }
                    label="Do you have any work experience"
                    sx={{
                      display: index > 0 ? "none" : "",
                    }}
                  />
                ) : (
                  <></>
                )}
                <Experince
                  userportaldata={experienceData}
                  handleChange={(e) => handleExperienceChange(e, exp.id)}
                  handleDateChange={(newValue, field) =>
                    handleDateChange(exp.id, newValue, field)
                  }
                  handleRemoveExperience={handleRemoveExperience}
                  handleAddExperience={handleAddExperience}
                  experince={experince}
                  setExperince={setExperince}
                  id={exp.id}
                  experienceFields={experienceFields.length}
                  errors={errors}
                  Percente={Percente}
                  handleRemovefile={handleRemovefile}
                  thresholdRef={thresholdRef}
                />
              </Box>
            );
          })}
        </>
      ),
    },
  ];

  const handleSubmit = (e) => {
    e.preventDefault();

    if (activeStep === 2) {
      if (!validateExperienceDetails()) {
        setErrorMessage("Please fill all required Experience details.");
        setOpen(true);
        return;
      } else {
        if (!userId) {
          setErrorMessage("User ID not found! Please complete step 1 first.");
          setOpen(true);
          return;
        }

        const filteredExperience = Array.isArray(userportaldata.Experience)
          ? userportaldata.Experience.map((exp) => {
              const cleanedExp = { ...exp };
              Object.keys(cleanedExp).forEach((key) => {
                if (Array.isArray(cleanedExp[key])) {
                  cleanedExp[key] = cleanedExp[key].filter((f) => f !== false);
                }
              });
              return cleanedExp;
            })
          : [];

        const educationalData = { ...userportaldata.Educational };
        Object.keys(educationalData).forEach((key) => {
          if (Array.isArray(educationalData[key])) {
            educationalData[key] = educationalData[key].filter(
              (item) => item !== false
            );
          }
        });

        const userportalDataExperienceDetail = {
          Experience: filteredExperience,
          Educational: educationalData,
        };

        updateDataByID(
          userId,
          userportalDataExperienceDetail,
          "financeUserPortal"
        );

        setErrorMessage("");
        setOpenPopup(true);
        setExperienceFields([{ id: 1 }]);
        setuserPortalData({
          Educational: {},
          Experience: [{ id: 1, ...defaultExperienceFields }],
        });
        setPercent({});
        setUserId("");
        localStorage.removeItem("verivication_portal_id");
        localStorage.removeItem("verivication_portal_fixedId");
        localStorage.removeItem("user_experience");
        localStorage.clear();
      }
    }
  };

  const validatePersonalDetails = () => {
    const { email , password ,name, motherName, fatherName, gender, mobilno, dob } =
      userportaldata;

    let newErrors = {};

    const textOnlyRegex = /^[A-Za-z\s]+$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    //const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/;

    
    if (!email) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(email)) {
      newErrors.email = "Please Enter Valid Email";
    }
    // if (!password) {
    //   newErrors.password = "Password is required";
    // } else if (!passwordRegex.test(password)) {
    //   newErrors.password = "Please Enter Valid Password";
    // }

    if (!name) {
      newErrors.name = "Name is required";
    } else if (!textOnlyRegex.test(name)) {
      newErrors.name = "Only alphabets allowed in Name";
    }
    if (!motherName) {
      newErrors.motherName = "Mother's Name is required";
    } else if (!textOnlyRegex.test(motherName)) {
      newErrors.motherName = "Only alphabets allowed in Mother's Name";
    }

    if (!fatherName) {
      newErrors.fatherName = "Father's Name is required";
    } else if (!textOnlyRegex.test(fatherName)) {
      newErrors.fatherName = "Only alphabets allowed in Father's Name";
    }

    if (!dob) {
      newErrors.dob = "Date Of Birth is required";
    }
    if (!gender) newErrors.gender = "Gender is required";

    const numbersOnlyRegex = /^\d{10}$/;
    if (!mobilno) {
      newErrors.mobilno = "Mobile Number is required";
    } else if (!numbersOnlyRegex.test(mobilno)) {
      newErrors.mobilno = "Enter a valid 10-digit Mobile Number";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);

      return;
    }
    return email && password && name && motherName && fatherName && gender && mobilno && dob;
  };

  const validateEducationalDetails = () => {
    const { Educational } = userportaldata;
    let newErrors = {};
    let semArraygraduation = [
      "grad_semone",
      "grad_semtwo",
      "grad_semthree",
      "grad_semfour",
      "grad_semfive",
      "grad_semsix",
      "grad_semseven",
      "grad_semeight",
    ];
    let semArraypostgraduation = [
      "postgrad_semone",
      "postgrad_semtwo",
      "postgrad_semthree",
      "postgrad_semfour",
    ];

    if (
      !Educational?.["10th"] ||
      (Array.isArray(Educational?.["10th"]) &&
        Educational?.["10th"][0] === false)
    ) {
      newErrors["10th"] = "Upload 10th certificate";
    }
    if (
      !Educational?.["12th"] ||
      (Array.isArray(Educational?.["12th"]) &&
        Educational?.["12th"][0] === false)
    ) {
      newErrors["12th"] = "Upload 12th certificate";
    }

    if (graduationchecked) {
      if (
        !Educational?.grad_degree ||
        (Array.isArray(Educational.grad_degree) &&
          Educational.grad_degree[0] === false)
      ) {
        newErrors["grad_degree"] = "Upload Graduation Degree";
      }

      semArraygraduation.forEach((item) => {
        if (
          !Educational?.[item] ||
          (Array.isArray(Educational[item]) && Educational[item][0] === false)
        ) {
          newErrors[item] = `Enter Graduation Year for ${item.slice(8)}`;
        }
      });
    }
    if (postgraduate) {
      if (
        !Educational?.postgrad_degree ||
        (Array.isArray(Educational.postgrad_degree) &&
          Educational.postgrad_degree[0] === false)
      ) {
        newErrors["postgrad_degree"] = "Upload postgraduation Degree";
      }

      semArraypostgraduation.forEach((item) => {
        if (
          !Educational?.[item] ||
          (Array.isArray(Educational[item]) && Educational[item][0] === false)
        ) {
          newErrors[item] = `Enter postgraduation Year for ${item.slice(12)}`;
        }
      });
    }
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return false;
    }
    return true;
  };
  const validateExperienceDetails = () => {
    const { Experience = [] } = userportaldata;
    let newErrors = {};

    if (experince) {
      Experience.forEach((exp) => {
        if (!exp || typeof exp !== "object") return;

        if (!exp.comp_name) {
          newErrors[`${exp.id}.comp_name`] = "Company name is required.";
        }
        if (!exp.Exp_years) {
          newErrors[`${exp.id}.Exp_years`] = "Experience is required.";
        }
        if (!exp.doj) {
          newErrors[`${exp.id}.doj`] = "Date of Joining is required.";
        }
        if (!exp.doe) {
          newErrors[`${exp.id}.doe`] = "Date of Exit is required.";
        }

        // let requiredDocs = [
        //   "doc_salarySlip",
        //   // "doc_offerLetter",
        //   // "doc_relievingLetter",
        //   // "doc_experienceLetter",
        // ];

        // requiredDocs.forEach((doc) => {
        //   if (
        //     !exp[doc] ||
        //     !exp[doc].length > 0 ||
        //     (Array.isArray(exp[doc]) && exp[doc][0] === false)
        //   ) {
        //     newErrors[`${exp.id}.${doc}`] = `${doc.slice(4)} is required.`;
        //   }

        //   if (doc === "doc_salarySlip") {
        //     if (Array.isArray(exp[doc]) && exp[doc].length >= 3) {
        //       delete newErrors[`${exp.id}.${doc}`];
        //     } else {
        //       newErrors[`${exp.id}.${doc}`] =
        //         "Minimum 3 salary slips are required.";
        //     }
        //   }
        // });
      });
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    const userportalDataPersonalDetail = {
      email: userportaldata.email,
      password: userportaldata.password,
      name: userportaldata.name,
      fatherName: userportaldata.fatherName,
      motherName: userportaldata.motherName,
      mobilno: userportaldata.mobilno,
      dob: userportaldata.dob,
      gender: userportaldata.gender,
    };

    if (activeStep === 0) {
      if (!validatePersonalDetails()) {
        setErrorMessage("Please fill all required Personal Details");
        setOpen(true);
        return;
      }
      if (!userId) {
        PostData(userportalDataPersonalDetail, "financeUserPortal", (res) => {
          setUserId(res.id);
          localStorage.setItem("verivication_portal_id", res.id);
          setActiveStep((prevStep) => prevStep + 1);
          setErrorMessage("");
        });
      } else {
        setActiveStep((prevStep) => prevStep + 1);
        setErrorMessage("");
      }
    }

    if (activeStep === 1) {
      if (!validateEducationalDetails()) {
        setErrorMessage("Please fill all required Educational Details.");
        setOpen(true);
        return;
      }

      if (!userId) {
        setErrorMessage("User ID not found! Please complete step 1 first.");
        setOpen(true);
        return;
      }
      const userportalDataEducationalDetail = {
        Educational: userportaldata.Educational,
      };
      updateDataByID(
        userId,
        userportalDataEducationalDetail,
        "financeUserPortal"
      )
        .then(() => {
          setActiveStep((prevStep) => prevStep + 1);
          setErrorMessage("");
        })
        .catch((err) => console.error("Error updating data:", err));
    }
  };

  const handleBack = () => setActiveStep((prev) => prev - 1);

  const handleClose = (value) => {
    setOpenPopup(value);
    setActiveStep(0);
  };

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  const SlideTransition = (props) => {
    return <Slide {...props} direction="down" />;
  };
  return (
    <>
      <Container maxWidth={false}>
        <Box
          sx={{
            display: window.innerWidth < 769 ? "" : "flex",
            justifyContent: "center",
            alignContent: "center",
            p: window.innerWidth < 600 ? "" : 2,
          }}
        >
          <form
            onSubmit={handleSubmit}
            style={{ width: window.innerWidth < 769 ? "100%" : "80%" }}
          >
            <Stepper activeStep={activeStep} orientation="vertical">
              {staticSteps.map((step, index) => (
                <Step key={index}>
                  <StepLabel>{step.label}</StepLabel>
                  <StepContent
                    sx={{
                      paddingLeft:
                        index === staticSteps.length - 1 ? "0px" : "",
                    }}
                  >
                    {step.content()}
                    <Box>
                      {experienceFields.length > 1 &&
                        index === staticSteps.length - 1 &&
                        experince === true && (
                          <Button
                            variant="outlined"
                            onClick={handleAddExperience}
                            className="btn-light"
                            sx={{
                              padding: "3px 16px !important",
                              height: "40px",
                              fontSize: {
                                xs: "10px !important",
                                sm: "10px !important",
                                md: "13px !important",
                                lg: "13px !important",
                              },
                              minWidth: "120px",
                              ":hover": {
                                padding: "3px 16px !important",
                                fontSize: "13px !important",
                                height: "40px",
                              },
                            }}
                          >
                            Add More Experience
                          </Button>
                        )}
                    </Box>
                    <Box sx={{ mt: 2 }}>
                      {index === staticSteps.length - 1 ? (
                        <Button
                          variant="contained"
                          type="submit"
                          className="btn-light"
                          sx={{
                            padding: "3px 16px !important",
                            height: "40px",
                            fontSize: {
                              xs: "10px !important",
                              sm: "10px !important",
                              md: "13px !important",
                              lg: "13px !important",
                            },
                            mr: 1,
                            minWidth: "120px",
                            ":hover": {
                              padding: "3px 16px !important",
                              fontSize: "13px !important",
                              height: "40px",
                            },
                          }}
                        >
                          Submit
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                          onClick={handleNext}
                          className="btn-light"
                          sx={{
                            padding: "3px 16px !important",
                            height: "40px",
                            fontSize: {
                              xs: "10px !important",
                              sm: "10px !important",
                              md: "13px !important",
                              lg: "13px !important",
                            },
                            mr: 1,
                            minWidth: "120px",
                            ":hover": {
                              padding: "3px 16px !important",
                              fontSize: "13px !important",
                              height: "40px",
                            },
                          }}
                        >
                          Continue
                        </Button>
                      )}

                      {index > 0 && (
                        <Button
                          onClick={handleBack}
                          className="btn-light"
                          sx={{
                            padding: "3px 16px !important",
                            height: "40px",
                            fontSize: {
                              xs: "10px !important",
                              sm: "10px !important",
                              md: "13px !important",
                              lg: "13px !important",
                            },
                            mr: 1,
                            minWidth: "120px",
                            ":hover": {
                              padding: "3px 16px !important",
                              fontSize: "13px !important",
                              height: "40px",
                            },
                          }}
                        >
                          Back
                        </Button>
                      )}
                    </Box>
                  </StepContent>
                </Step>
              ))}
            </Stepper>
          </form>
        </Box>
        <Snackbar
          open={open}
          onClose={handleCloseAlert}
          autoHideDuration={2000}
          TransitionComponent={SlideTransition}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          sx={{
            top: { xs: "24px", sm: "70px" },
          }}
          aria-hidden={false}
        >
          <Alert
            onClose={handleCloseAlert}
            severity="error"
            variant="filled"
            sx={{ width: "100%" }}
          >
            {errorMessage}
            <Box
              sx={{ width: "100%", position: "absolute", bottom: 0, left: 0 }}
            >
              <LinearProgress
                variant="determinate"
                value={100}
                sx={{
                  animation: "progress 2s linear forwards",
                  "@keyframes progress": {
                    "0%": { width: "0%" },
                    "100%": { width: "100%" },
                  },
                  ".css-l16vtb-MuiLinearProgress-bar1": {
                    backgroundColor: "#9b2222",
                  },
                }}
              />
            </Box>
          </Alert>
        </Snackbar>
        <FormSubmit
          open={openPopup}
          handleClose={handleClose}
          disableEnforceFocus
        />
      </Container>
    </>
  );
};

export default EmployeeForm;
